module.exports = __webpack_public_path__ + "media/flags/au-eb0518ba.svg";